function SelectTasksStep({ chantierTypeName, tasks, loading, selectedTaskIds, onToggle, onSelectAll, onDeselectAll }) {
  if (loading) {
    return (
      <div className="TypeTree-loading">
        <span className="Spinner" />
      </div>
    );
  }

  if (tasks.length === 0) {
    return (
      <div className="TaskList-empty">
        <p>Aucune tâche suggérée pour ce type de projet.</p>
        <p className="TaskList-emptySub">Vous pourrez en ajouter manuellement après la création.</p>
      </div>
    );
  }

  const allSelected = selectedTaskIds.size === tasks.length;

  return (
    <div className="Modal-form">
      <div className="TaskList-header">
        <div>
          <p className="TaskList-count">{selectedTaskIds.size} tâche(s) sélectionnée(s)</p>
          <p className="TaskList-total">sur {tasks.length}</p>
        </div>
        <button
          type="button"
          className="TaskList-toggleAll"
          onClick={allSelected ? onDeselectAll : onSelectAll}
        >
          {allSelected ? 'Tout désélectionner' : 'Tout sélectionner'}
        </button>
      </div>

      <p className="Modal-info">
        Tâches suggérées pour « {chantierTypeName} ». Décochez celles que vous ne souhaitez pas créer.
      </p>

      <div className="TaskList">
        {tasks.map((task) => {
          const isSelected = selectedTaskIds.has(task.id);
          const color = task.metier?.color || '#f6a500';
          return (
            <button
              type="button"
              key={task.id}
              className={`TaskCard${isSelected ? ' is-selected' : ''}`}
              style={{ borderColor: isSelected ? color : 'transparent' }}
              onClick={() => onToggle(task.id)}
            >
              <span className="TaskCard-bar" style={{ backgroundColor: color }} />
              <span
                className={`TaskCard-checkbox${isSelected ? ' is-checked' : ''}`}
                style={isSelected ? { backgroundColor: color, borderColor: color } : undefined}
              >
                {isSelected && '✓'}
              </span>
              <span className="TaskCard-content">
                <span className="TaskCard-title">{task.title}</span>
                {task.description && <span className="TaskCard-description">{task.description}</span>}
                {task.metier?.name && (
                  <span className="TaskCard-metier">
                    <span className="TaskCard-metierDot" style={{ backgroundColor: color }} />
                    {task.metier.name}
                  </span>
                )}
              </span>
            </button>
          );
        })}
      </div>
    </div>
  );
}

export default SelectTasksStep;
